import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { components, contentfulViews, contentfulModels } from '@glowforge/ui-common';

import './job-description.less';

const { Markdown } = components;
const { ButtonLink, PageMetadata } = contentfulViews;
const { interpretMetadata } = contentfulModels;

const JobDescriptionPage = (props) => {
  const applyButton = (
    <ButtonLink
      text='Apply to this Job'
      type='default'
      size='small'
      url={props.page.applicationLink} />
  );

  const location = props.page.location ? props.page.location : 'Seattle, WA';
  const employmentType = props.page.employmentType ? props.page.employmentType : 'Full-time';
  return (
    <div className='JobDescriptionPage contentPage'>
      <PageMetadata
        {...interpretMetadata(props.page.metadata, {
          title: props.page.title,
          location,
          employmentType,
        })} />
      <div className='content'>
        <h1 className='title h1'>
          {props.page.title}
        </h1>
        <div className='actionRow'>
          <h3 className='label h4'>{location} - {employmentType}</h3>
          {applyButton}
        </div>
        <Markdown className='paragraph' source={props.page.jobDescription} />
        <div className='actionRow bottom'>{applyButton}</div>
        <Markdown className='paragraph' source={props.callToAction} />
      </div>
    </div>
  );
};

JobDescriptionPage.propTypes = {
  page: PropTypes.shape({
    title: PropTypes.string.isRequired,
    applicationLink: PropTypes.string.isRequired,
    jobDescription: PropTypes.string.isRequired,
    location: PropTypes.string,
    employmentType: PropTypes.string,
    metadata: PropTypes.shape({}).isRequired,
  }).isRequired,
  callToAction: PropTypes.string.isRequired,
};

export default JobDescriptionPage;



// WEBPACK FOOTER //
// ./app/components/company/job-description.jsx